import { render, staticRenderFns } from "./CalculatePayrollForm.vue?vue&type=template&id=46b19540&"
import script from "./CalculatePayrollForm.vue?vue&type=script&lang=js&"
export * from "./CalculatePayrollForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports